var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransgender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.5 0V39.9778H392.189L313.624 118.543C296.688 106.823 276.159 99.9446 254.05 99.9446C232.069 99.9446 211.65 106.743 194.772 118.339L138.219 61.7867L171.16 29.2038L143.047 0.780567L109.95 33.5174L76.8344 0.401777L48.566 28.6711L81.5268 61.6318L51.0976 91.7301L79.211 120.152L109.796 89.9001L166.696 146.8C155.592 163.443 149.108 183.421 149.108 204.886C149.108 255.917 185.724 298.549 234.061 307.91V337.813H189.086V377.79H234.061V435.974L199.473 401.385L171.204 429.654L253.551 512L335.899 429.654L307.629 401.385L274.041 434.975V377.79H319.016V337.813H274.041V307.91C322.378 298.549 358.994 255.917 358.994 204.886C358.994 183.55 352.587 163.684 341.606 147.1L423.458 65.2478V119.933H463.436V0H343.5ZM254.05 269.85C218.229 269.85 189.086 240.707 189.086 204.886C189.086 169.065 218.229 139.922 254.05 139.922C289.871 139.922 319.014 169.065 319.014 204.886C319.014 240.707 289.871 269.85 254.05 269.85Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransgender);
export default __webpack_public_path__ + "static/media/Transgender.41dfddf58e28e0e02032c23f1f2854a2.svg";
export { ForwardRef as ReactComponent };